var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pie-chart',{attrs:{"data":_vm.estatisticas,"donut":true,"height":"200px","colors":[ '#53b256','#fe9f43']}})}
var staticRenderFns = []

export { render, staticRenderFns }